import { Pipe, PipeTransform } from '@angular/core'
import { Question, QuestionType } from '@app/domain/Question'

@Pipe({
    name: 'questionTypeName',
})
export class QuestionTypeNamePipe implements PipeTransform {

    transform(value: QuestionType | Question): string {
        if (value instanceof Question) {
            if (value.type === QuestionType.DOB && value.text) {
                return 'Day of the Year'
            }
            return this.nameForType(value.type)
        }
        return this.nameForType(value)
    }

    private nameForType(type: QuestionType): string {
        switch (type) {
        case QuestionType.Checkbox:
            return 'Yes/No'
        case QuestionType.Dropdown:
            return 'Multiple Choice'
        case QuestionType.AcknowledgeEndTime:
            return 'Acknowledge End Time'
        case QuestionType.DOB:
            return 'Ask for Birthday'
        case QuestionType.ReasonsForVisit:
            return 'Reason for visit'
        case QuestionType.DietaryRestrictions:
            return 'Dietary Restrictions'
        case QuestionType.DietaryRestrictionsText:
            return 'Dietary Restrictions (Text)'
        case QuestionType.Text:
            return 'Text'
        }
    }
}
